class Toolbarmobile extends HTMLElement {
  constructor() {
    super();

    if (theme.config.mqlSmall || theme.config.isTouch) this.init();
  }

  init() {
    this.activate();
    this.setHeight();
    window.addEventListener('resize', theme.utils.rafThrottle(this.setHeight.bind(this)));

    const repaint = theme.utils.rafThrottle(this.repaint.bind(this));
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', repaint);
      window.visualViewport.addEventListener('scroll', repaint);
    }
    window.addEventListener('scroll', () => {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(repaint, 150);
    }, { passive: true });
    window.addEventListener('pageshow', repaint);
  }

  activate() {
    const header = document.querySelector(".header[data-sticky-state='inactive]");
    header === null
      ? this.classList.add("active")
      : this.classList.remove("active");
  }

  setHeight() {
    document.body.style.setProperty('--toolbar-mobile-height', `${this.clientHeight}px`);
  }

  repaint() {
    this.style.bottom = '0.5px';
    requestAnimationFrame(() => {
      this.style.bottom = '';
    });
  }
}
customElements.define("toolbar-mobile", Toolbarmobile);
